import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {TokenStorage} from '../../auth/token-storage.service';
import {AppConfig} from '../../../config/appConfig';
import {Observable} from 'rxjs';
import {Cliente} from '../../models/api/Cliente';
import {ResultObject} from '../../models/api/ResultObject';
import {ServicePattern} from '../../models/interface/ServicePattern';
import {EstabelecimentoFunctions} from '../../models/interface/EstabelecimentoFunctions';
import {Notificacao} from '../../models/api/Notificacao';
import {tap} from 'rxjs/operators';

@Injectable()
export class NotificacoesService extends EstabelecimentoFunctions implements ServicePattern<Notificacao> {

	constructor(private http: HttpClient, private tokenStorage: TokenStorage) {
		super();
	}

	getAll(dateFilter: { dataInicio: Date, dataFim: Date } = { dataInicio: null, dataFim: null }, componentId: string = ''): Observable<Notificacao[]> {
		return this.http.get<Notificacao[]>(
			AppConfig.getAPIEndpoint() + '/notificacoes/list/' + this.tokenStorage.getUserInfo().idUsuario,
			{
				headers: AppConfig.getHTTPHeader().headers.set('componentId', componentId),
				params: {
					...this.getEstabelecimentoQueryParam(),
					...this.getDateFilterQueryParam(dateFilter.dataInicio, dateFilter.dataFim)
				}
			}
		);
	}

	get(idCliente: number): Observable<Notificacao> {
		// TODO
		return null;
	}

	save(body: Notificacao): Observable<ResultObject<any>> {
		// TODO
		return null;
	}

	update(body: Notificacao): Observable<ResultObject<any>> {
		// TODO
		return null;
	}

	delete(idNotificacao: number): Observable<ResultObject<any>> {
		// TODO
		return null;
	}

}
